/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  // someThing: () => _t(translations.someThing,'default value'),
  name: () => _t(translations.Assets.name),
  totalAsset: () => _t(translations.Assets.totalAsset),
  TotalCurrent: () => _t(translations.Assets.TotalCurrent),
  totalGain: () => _t(translations.Assets.totalGain),
  todayChange: () => _t(translations.Assets.todayChange),
  annualReturn: () => _t(translations.Assets.annualReturn),
};
